import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { AccordionSummary } from '@lyearn/ui';

type Props = React.ComponentProps<typeof AccordionSummary>;

const accordionSummaryStyles = css`
  &.MuiAccordionSummary-root {
    min-height: auto;
    padding: 0;

    &.Mui-expanded {
      min-height: auto;
    }

    .MuiAccordionSummary-content {
      margin: 0;

      &.Mui-expanded {
        margin: 0;
      }
    }
  }
`;

const AccordionSummaryComponent: React.FC<Props> = (props) => {
  const { className, ...rest } = props;

  return <AccordionSummary className={cn(accordionSummaryStyles, className)} {...rest} />;
};

export default AccordionSummaryComponent;
